import React from "react"
import { Button, Col, Input, Row } from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import ManualStatus from "./ManualStatus"
import axios from "axios"

const UploadFiles = ({ loading, setLoading, setBatchID, setLayout }) => {
  const formik = useFormik({
    initialValues: {
      pdfFile: null,
      csvFile: null,
      uploadStatus: false,
    },
    validationSchema: Yup.object({
      pdfFile: Yup.mixed()
        .required("PDF file is required")
        .test(
          "fileFormat",
          "Only PDF files are allowed",
          value => value && value.type === "application/pdf"
        ),
      csvFile: Yup.mixed().when("uploadStatus", {
        is: true,
        then: schema =>
          schema
            .required("CSV file is required")
            .test(
              "fileFormat",
              "Only CSV files are allowed",
              value =>
                value &&
                (value.type === "text/csv" ||
                  value.name.endsWith(".xls") ||
                  value.name.endsWith(".xlsx") ||
                  value.name.endsWith(".csv"))
            ),
        otherwise: schema => schema.notRequired(),
      }),
    }),
    onSubmit: values => {
      console.log("values", values)
      const formData = new FormData()
      formData.append("PerToken", localStorage.getItem("token"))
      formData.append("PerUserID", localStorage.getItem("id"))
      formData.append("PerRoleID", localStorage.getItem("userRoleID"))

      formData.append("PDF", values.pdfFile)
      if (values.uploadStatus) {
        formData.append("Excel", values.csvFile)
      }

      setBatchID(null)

      setLayout("loading")

      axios
        .post(
          process.env.REACT_APP_API_URL + `api/BaladyDetails/Upload.php`,
          formData
        )
        .then(res => {
          if (
            res.data.error === true &&
            res.data.message === "Access denied!"
          ) {
            setAuth(true)
            setTimeout(() => {
              history.push("/logout")
              setTimeout(() => {
                history.push("/login")
              }, 1000)
            }, 4000)
          }

          console.log("res.data", res.data)

          setBatchID(res.data.BatchID)
        })
        .catch(err => {
          console.log(err)
        })
    },
  })

  return (
    <div
      style={{
        // border: "1px solid lightgray",
        borderRadius: "10px",
        width: "80%",
        minHeight: "70vh",
        margin: "auto",
      }}
      className="p-3"
    >
      <form onSubmit={formik.handleSubmit}>
        <Row>
          <Col
            sm={3}
            className="d-flex justify-content-center align-items-center"
          >
            <label htmlFor="pdfFile">Upload new session</label>
          </Col>
          <Col sm={9}>
            <Input
              type="file"
              id="pdfFile"
              accept="application/pdf"
              onChange={e => {
                formik.setFieldValue("pdfFile", e.target.files[0])
              }}
            />
            {formik.errors.pdfFile && formik.touched.pdfFile && (
              <div className="text-danger">{formik.errors.pdfFile}</div>
            )}
          </Col>
        </Row>

        <Row className="my-3">
          <Col
            sm={3}
            className="d-flex justify-content-center align-items-center"
          >
            <Input
              className=" mb-2"
              type="checkbox"
              id="uploadStatus"
              // checked={formik.values.uploadStatus}
              onChange={e => {
                console.log("formik.values", formik.values)
                formik.setFieldValue("uploadStatus", e.target.checked)
              }}
            />
            <label
              style={{ cursor: "pointer" }}
              htmlFor="uploadStatus"
              className="mx-3"
            >
              Upload status
            </label>
          </Col>
          <Col sm={9}>
            <Input
              type="file"
              id="csvFile"
              // accept=".csv,text/csv,application/vnd.ms-excel"
              accept=".xls,.xlsx,.csv"
              disabled={!formik.values.uploadStatus}
              onChange={e => {
                formik.setFieldValue("csvFile", e.target.files[0])
              }}
            />
            {formik.errors.csvFile && formik.touched.csvFile && (
              <div className="text-danger">{formik.errors.csvFile}</div>
            )}
          </Col>
        </Row>

        <Row className="mb-5">
          <Col sm={12} className="d-flex justify-content-end">
            <Button type="submit">Submit</Button>
          </Col>
        </Row>
      </form>

      <ManualStatus />
    </div>
  )
}

export default UploadFiles
